import React from 'react';
import '../components/MainPage/ServiceCards.css';

const formats = [
  {
    id: 'TimeMaterial',
    name: 'Time & Material',
    text: 'Наши разработчики и аналитики работают в вашей команде. Вы определяете задачи и приоритеты. '
      + 'Отказаться от специалиста можно в любой момент.',
    payment: 'Ежемесячно, по отчёту о затраченном времени.',
  },
  {
    id: 'FixedPrice',
    name: 'Fixed Price',
    text: 'Закрепляем требования, цену и сроки в договоре. Если недооценили объём, завершаем работу за свой счёт '
      + 'при неизменных требованиях. Гарантия на исправление ошибок — обычно от 3 месяцев до года.',
    payment: 'Аванс 30–40%, остальное после приёмки.',
  },
  {
    id: 'Outsource',
    name: 'Аутсорс',
    text: 'Берём проект или его часть. Договариваемся, кто управляет работой: ваша команда, наша или обе вместе. '
      + 'Согласуем задачи и оценку релизов, заменяем специалистов на время отпуска или болезни. Даём гарантию на результат.',
    payment: 'Ежемесячно, по отчёту о реализованных задачах.',
  },
];

const CollaborationPage: React.FC = () => (
  <section
    aria-labelledby="collaboration-title"
    className="collaboration-section section-space"
    id="Collaboration"
  >
    <div className="landing-container">
      <div
        className="section-heading"
        data-flow-reveal
      >
        <p className="eyebrow">
          <span className="section-index">04 /</span>
          {' '}
          СОТРУДНИЧЕСТВО
        </p>
        <div className="heading-columns">
          <h2 id="collaboration-title">
            Формат работы
            <br />
            <span className="muted-title">под ваш проект.</span>
          </h2>
          <p>Отдельные специалисты, задача с фиксированной ценой или проект целиком. Договоримся об ответственности, порядке работы и оплате.</p>
        </div>
      </div>
      <div
        className="collaboration-cards"
        data-flow-reveal
      >
        {formats.map((format) => (
          <article
            key={format.id}
            className="collaboration-card"
            id={format.id}
          >
            <div className="collaboration-card-heading">
              <h3>{format.name}</h3>
            </div>
            <p className="collaboration-card-description">{format.text}</p>
            <dl className="collaboration-card-terms">
              <div>
                <dt>Оплата</dt>
                <dd>{format.payment}</dd>
              </div>
            </dl>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default CollaborationPage;
